<div class="flex flex-col items-center">
  <div class="w-full px-4">
    <div class="flex justify-between w-full" [class]="isMobile ? 'flex-col' : 'flex-row'">
      <!-- Título inicial cuando no hay categoría seleccionada -->
      <div *ngIf="!selectedCategory || !viewingSubcategories"
           class="w-full max-w-[550px] flex items-center gap-4 my-4 text-white">
        <ion-label class="font-bold text-white" [class]="isMobile ? 'text-2xl md:text-3xl' : 'text-4xl'">
          {{ 'HOME.WHAT_LOOKING_FOR' | translate }}
        </ion-label>
      </div>

      <!-- Botón de retroceso cuando hay categoría seleccionada y estamos viendo subcategorías -->
      <button *ngIf="selectedCategory && viewingSubcategories" (click)="showAll()"
              class="w-full max-w-[450px] flex items-center gap-4 my-4 text-white hover:opacity-80 transition-opacity">
        <ion-icon src="../../../assets/svg/arrowLeft.svg" class="text-2xl"></ion-icon>
        <ion-label class="text-2xl md:text-4xl font-bold text-white">{{ selectedCategory.name }}</ion-label>
      </button>

      <div class="flex max-w-lg gap-2 w-full" [ngClass]="{'flex-col': isMobile}">
        <ion-button color="success" class="app-shadow" [class]="isMobile ? 'h-11' : 'flex-1'" size="small" mode="ios"
                    (click)="setPostToCreate(0)">
          <ion-label class="text-sm font-bold">{{ 'HOME.FOUND_SOMETHING' | translate }}</ion-label>
        </ion-button>
        <ion-button color="danger" class="app-shadow" [class]="isMobile ? 'h-11' : 'flex-1'" size="small" mode="ios"
                    (click)="setPostToCreate(1)">
          <ion-label class="text-sm font-bold">{{ 'HOME.LOST_SOMETHING' | translate }}</ion-label>
        </ion-button>
      </div>
    </div>

    <div class="swiper-container-wrapper">
      <!-- Mostrar spinner de carga cuando se están cargando subcategorías -->
      <div *ngIf="viewingSubcategories && isLoadingSubcategories && subcategories.length === 0"
           class="flex w-full py-20">
        <ion-spinner name="circular" color="light"></ion-spinner>
      </div>

      <div class="swiper-wrapper-custom justify-center" *ngIf="!viewingSubcategories || !isLoadingSubcategories">
        <swiper-container
          #swiperRef
          class="categories-swiper justify-center"
          slides-per-view="auto"
          space-between="20"
          free-mode="false"
          [loop]="isMobile"
          speed="300">

          <!-- Categorías principales -->
          <ng-container *ngIf="!viewingSubcategories">
            <!-- Opción "Ver todo" -->
            <swiper-slide lazy="true" class="swiper-slide-custom justify-center">
              <div class="slide-content">
                <app-category-web [category]="viewAllCategory" (click)="select(viewAllCategory)"></app-category-web>
              </div>
            </swiper-slide>
            <!-- Categorías individuales -->
            <swiper-slide lazy="true" *ngFor="let category of items" class="swiper-slide-custom">
              <div class="slide-content">
                <app-category-web [category]="category" (click)="select(category)"></app-category-web>
              </div>
            </swiper-slide>
          </ng-container>

          <!-- Subcategorías -->
          <ng-container *ngIf="viewingSubcategories">
            <!-- Opción "Ver todo" para subcategorías -->
            <swiper-slide class="swiper-slide-custom">
              <div class="slide-content">
                <app-category-web [category]="viewAllSubcategory"
                                  (click)="select(viewAllSubcategory)"></app-category-web>
              </div>
            </swiper-slide>
            <!-- Subcategorías individuales -->
            <swiper-slide *ngFor="let subcategory of subcategories" class="swiper-slide-custom">
              <div class="slide-content">
                <app-category-web [category]="subcategory" (click)="select(subcategory)"></app-category-web>
              </div>
            </swiper-slide>
          </ng-container>
        </swiper-container>

        <!-- Botones de navegación -->
        <div class="navigation-buttons">
          <button
            type="button"
            [attr.disabled]="!activePrevious ? '' : null"
            class="custom-prev nav-button mr-4"
            [class.disabled]="!activePrevious"
            (click)="goToPrevSlide($event)">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </button>
          <button
            type="button"
            [attr.disabled]="!activeNext ? '' : null"
            class="custom-next nav-button"
            [class.disabled]="!activeNext"
            (click)="goToNextSlide($event)">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Mensajes de estado vacío para categorías/subcategorías -->
    <div *ngIf="!viewingSubcategories && !isLoading && items.length === 0" class="text-white text-center w-full py-4">
      {{ 'HOME.NO_CATEGORIES' | translate }}
    </div>
    <div *ngIf="viewingSubcategories && !isLoadingSubcategories && subcategories.length === 0" class="text-white text-center w-full py-4">
      {{ 'HOME.NO_SUBCATEGORIES' | translate }}
    </div>

    <div class="flex flex-col text-white gap-4 mt-16" [ngClass]="{ 'my-10': isMobile }">
      <ion-label class="font-bold" [class]="isMobile ? 'text-2xl md:text-3xl' : 'text-4xl'">
        {{ 'HOME.LOST_OR_FOUND_QUESTION' | translate }}
      </ion-label>
      <ion-label class="max-w-[760px] text-sm md:text-base">{{ 'HOME.CREATE_POST_DESCRIPTION' | translate }}</ion-label>

      <ion-button color="light" mode="ios" class="w-fit mt-4" (click)="newPost()">
        <ion-label class="mr-3">{{ 'HOME.NEW_POST' | translate }}</ion-label>
        <ion-icon class="text-[14px]" src="../../../assets/svg/plus2.svg"></ion-icon>
      </ion-button>
    </div>
  </div>


</div>

<app-dialog [show]="isGuest" type="accept" (toggle)="isGuest = false" (confirm)="confirm()" [close]="true">
  <ion-label class="text-[13px] text-[#131C4F] mt-6" [innerHTML]="'AUTH.SIGN_IN_NOTICE' | translate"></ion-label>
</app-dialog>

<app-dialog [show]="show" type="accept" (toggle)="show = false" (confirm)="confirmLogin()" [close]="true">
  <ion-label class="text-[13px] mt-4 text-[#131C4F]" [innerHTML]="'AUTH.SIGN_IN_NOTICE' | translate"></ion-label>
</app-dialog>

<!-- Footer con enlaces de descarga para apps -->
<div class="footer-download-apps w-full mt-8 flex flex-col items-center">
  <div class="container mx-auto px-4">
    <h3 class="text-white text-center text-2xl font-bold mb-6">{{ 'HOME.DOWNLOAD_OUR_APP' | translate }}</h3>
    <div class="flex justify-center items-center space-x-6 flex-wrap">
      <!-- Botón de descarga para Android -->
      <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer" class="app-download-button">
        <img src="../../../assets/images/store-android.png" alt="Descarga en Google Play" class="h-16">
      </a>
      <!-- Botón de descarga para iOS -->
      <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" class="app-download-button">
        <img src="../../../assets/images/store-ios.png" alt="Descarga en App Store" class="h-16">
      </a>
    </div>
    <p class="text-white text-center text-sm mt-4">{{ 'HOME.DOWNLOAD_APP_DESCRIPTION' | translate }}</p>
    <div class="home-web-footer-legal mt-6">
      <button
        type="button"
        class="home-web-footer-link home-web-footer-link--cookie-settings"
        (click)="openCookieSettings()"
      >
        {{ 'HOME.WEB_COOKIE_SETTINGS' | translate }}
      </button>
      <button
        type="button"
        class="home-web-footer-link home-web-footer-link--cookie-policy"
        (click)="openCookiePolicy()"
      >
        {{ 'HOME.WEB_COOKIE_POLICY' | translate }}
      </button>
      <button
        type="button"
        class="home-web-footer-link home-web-footer-link--privacy-policy"
        (click)="openPrivacyPolicy()"
      >
        {{ 'HOME.WEB_PRIVACY_POLICY' | translate }}
      </button>
    </div>
  </div>
</div>
